// extracted by mini-css-extract-plugin
module.exports = {"container":"_2bpp","chatNow":"DYIW","chatNowExternal":"_4Ndw","separatorExternal":"_5WsQ","left":"FXnC","separator":"N4xQ","degreeName":"_4uR1"};